export default {
  computed: {
    refFormName() {
      return Object.keys(this.$refs).find((t) => t.endsWith('Form'))
    },
    computedForm() {
      return Object.assign({}, this.form)
    },
    rulesKey() {
      return Object.keys(this.rules || {})
    },
  },
  watch: {
    computedForm: {
      deep: true,
      handler(newValue, oldValue) {
        Object.keys(newValue).forEach((k) => {
          /** validando autocompletado */
          if (
            (!!newValue[k] && !oldValue[k]) ||
            (!!oldValue[k] && !newValue[k])
          ) {
            if (this.rulesKey.includes(k)) {
              this.$refs[this.refFormName].validateField(k)
            }
          }
        })
      },
    },
  },
  methods: {
    handleFocus(event) {
      const field = event.target.name
      if (field) this.$refs[this.refFormName].clearValidate(field)
    },
  },
}
